import PhoneNumberMatcher from './PhoneNumberMatcher';

export default function findNumbers(text, options, metadata) {
	var matcher = new PhoneNumberMatcher(text, options, metadata);
	var results = [];
	while (matcher.hasNext()) {
		results.push(matcher.next());
	}
	return results;
}
//# sourceMappingURL=findNumbers_.js.map


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/es6/findNumbers_.js
// module id = bymb
// module chunks = 0